import { useCurrentUser } from '@treneo/features/user';

import { PermissionCodes } from '../data/permission-codes';

export const useHasAnyAdminPermission = (): boolean => {
  const { hasAnyPermission, hasPermissionInAnyOrganization } = useCurrentUser();

  return (
    hasAnyPermission(
      PermissionCodes.ManageHangfire,
      PermissionCodes.ViewHealth,
      PermissionCodes.ManageIdentity
    ) || hasPermissionInAnyOrganization(PermissionCodes.ManageOrganization)
  );
};
